import React, { FC } from 'react';
import { ReactComponent as ReportMenuButton } from '../../../assets/Reports/ReportMenuButton.svg';

export const ReportMenuButtonIcon: FC = () => <ReportMenuButton />;
